// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1fulw","content":"styles_content__39-sL","checkbox":"styles_checkbox__vQIdI","checkboxLabel":"styles_checkboxLabel__1xa7p"};